import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/styles';
import React from 'react';
import ShowMoreText from 'react-show-more-text';

export default function KanisaNotificationCard({
    name,
    venue,
    desc,
    date,
    time,
}) {
    const theme = useTheme();

    return (
        <Card
            variant="outlined"
            style={{
                borderRadius: theme.shape.borderRadius,
                marginBottom: 8,
                borderWidth: 2,
            }}
        >
            <CardContent
                style={{
                    paddingBottom: 20,
                }}
            >
                <Typography variant="h6">{name}</Typography>
                <Typography variant="h6">{venue}</Typography>
                <ShowMoreText lines={2} more="more" less="less">
                    <div dangerouslySetInnerHTML={{ __html: desc }}></div>
                </ShowMoreText>

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography color="text.secondary" className="fw-bold">
                        {date}
                    </Typography>
                    <Typography color="text.secondary" className="fw-bold">
                        {time}
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
}
